<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :class="[isCollapse ? 'my-el-menu' : '']"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.id"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import { generatorMap, isEmpty } from '@/utils'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'sidebar',
      'navList',
      'brandInfo',
      'companyInfo',
      'originNavList',
      'hierarchyType',
      'userInfo',
      'backMenuConfig',
      'isOpenGxms',
      'groupPayType',
      'isOpenScms',
      'shopInfo'
    ]),
    routes() {
      let originNavList = []
      if (this.backMenuConfig.length > 0) {
        this.backMenuConfig.forEach(info => {
          if (this.originNavList.some(item => item.id === info.id)) {
            let obj = this.originNavList.find(item => item.id === info.id)
            obj = Object.assign({}, obj)
            if (!isEmpty(info.name)) {
              obj.name = info.name
            }
            originNavList.push(obj)
          }
        })
      } else {
        originNavList = JSON.parse(JSON.stringify(this.originNavList))
      }
      let _list = this.handleMenuList(originNavList || [])
      // let _list = JSON.parse(JSON.stringify(this.navList))
      if (!this.isOpenYy) {
        _list = _list.filter(info => info.id !== 'D64B8036')
      }
      if (!this.isOpenCommunityBuying) {
        _list = _list.filter(info => info.id !== 'ECFK8CA1')
      }
      if (!this.isOpenCheckIn) {
        _list = _list.filter(
          info =>
            info.id !== 'C5B9781C' && // 号云商圈管理
            info.id !== 'E668DFD6' && // 号云供应商管理
            info.id !== 'E44F4310' && // 号云评价管理
            info.id !== 'F37EDKD8' // 高校供应商管理
        )
      }
      if (!this.isOpenCkgl) {
        _list = _list.filter(info => info.id !== '8F7A2AE4')
      }
      if (!this.isOpenNews) {
        _list = _list.filter(info => info.id !== 'E572D8DA')
      }
      if (!this.isOpenStaffEvaluate) {
        _list = _list.filter(info => info.id !== '6A057DF8')
      }
      if (this.hierarchyType !== 'GS') {
        _list = _list.filter(info => info.id !== '6C59D02F')
      } else if (!this.isOpenWxService) {
        _list = _list.filter(info => info.id !== '6C59D02F')
      }
      if (!this.isOpenMdpj) {
        _list = _list.filter(info => info.id !== 'E18F44E1')
      }
      if (!this.isOpenDdpj) {
        _list = _list.filter(info => info.id !== '83FE4DE9')
      }
      if (!this.isOpenSphk && !this.isOpenAlnr) {
        _list = _list.filter(info => info.id !== 'B5FAF2E7')
      } else {
        if (_list.some(info => info.id !== 'B5FAF2E7')) {
          let obj = _list.find(info => info.id === 'B5FAF2E7')
          if (!this.isOpenSphk) {
            if (obj) {
              obj.children = obj.children.filter(item => item.id !== 'AB493EB3')
              _list = _list.filter(info => info.id !== 'AB493EB3')
            }
          }
          if (!this.isOpenAlnr) {
            if (obj) {
              obj.children = obj.children.filter(item => item.id !== 'E3D19F8E')
              _list = _list.filter(info => info.id !== 'E3D19F8E')
            }
          }
          if (!this.isOpenPtms) {
            if (obj) {
              obj.children = obj.children.filter(item => item.id !== 'EDCA629K')
              _list = _list.filter(info => info.id !== 'EDCA629K')
            }
          }
        }
      }
      if (!this.isOpenKfzx) {
        _list = _list.filter(info => info.id !== 'BA34C7A8')
      }
      if (this.isOpenGxms && this.groupPayType === '2') {
        // 高校模式，门店各自收款不需要——余额提现记录（菜单）
        // 门店账号不要余额菜单
        // if (_list.some(info => info.id === 'B25E368F')) {
        //   let obj = _list.find(info => info.id === 'B25E368F')
        //   obj.children = obj.children.filter(item => item.id !== 'ECAE1FD5')
        // }
        // if (_list.some(info => info.id === 'BDE2D2C5')) {
        //   let obj = _list.find(info => info.id === 'BDE2D2C5')
        //   obj.children = obj.children.filter(item => item.id !== 'A063A7F6')
        // }
        if (_list.some(info => info.id === 'DCA6BC70')) {
          let obj = _list.find(info => info.id === 'DCA6BC70')
          obj.children = obj.children.filter(item => item.id !== '1C6BC9E8')
        }
        if (_list.some(info => info.id === '5260C1FF')) {
          let obj = _list.find(info => info.id === '5260C1FF')
          obj.children = obj.children.filter(item => item.id !== 'F8630A17')
        }
      }
      if (this.isOpenGxms && this.hierarchyType === 'MD') {
        if (_list.some(info => info.id === '5260C1FF')) {
          let obj = _list.find(info => info.id === '5260C1FF')
          if (this.shopOpenProfit) {
            obj.children = obj.children.filter(item => item.id !== '23A4F269')
          } else {
            obj.children = obj.children.filter(item => item.id !== 'E6A344B9')
          }
        }
      }
      if (this.isOpenGxms) {
        // 集团分账
        if (_list.some(info => info.id === 'EE6DC169')) {
          let obj = _list.find(info => info.id === 'EE6DC169')
          obj.children = obj.children.filter(item => item.id !== 'FAC704D8')
        }
        // 财务管理---站长分账
        if (_list.some(info => info.id === '77372C7B')) {
          let obj = _list.find(info => info.id === '77372C7B')
          obj.children = obj.children.filter(item => item.id !== 'DA0D8E8E')
        }
      }
      // 招聘板块
      if (!this.isOpenZpbk) {
        _list = _list.filter(info => info.id !== 'BC7240C3')
        _list = _list.filter(info => info.id !== 'BEB7477A')
        _list = _list.filter(info => info.id !== 'C251DFA8')
      }
      // 霸王餐
      if (!this.isOpenBwcgn) {
        _list = _list.filter(info => info.id !== 'CD7A325E')
      }
      // 零食盒子
      if (!this.isOpenLshz) {
        _list = _list.filter(info => info.id !== 'B22B6E03')
      }
      if (!this.isOpenTcjy) {
        _list = _list.filter(info => info.id !== 'E0F5BC03')
      }
      // 运营考核
      if (!this.isOpenSiteExamine) {
        if (_list.some(info => info.id === '3D14CCEE')) {
          let obj = _list.find(info => info.id === '3D14CCEE')
          obj.children = obj.children.filter(item => item.id !== 'E8B1B27D')
        }
        // _list = _list.filter(info => info.id !== 'E8B1B27D')
      }
      // 活动赛事
      if (!this.isOpenHdss) {
        _list = _list.filter(info => info.id !== '8F379E47')
      }
      // 论坛
      if (!this.isOpenLt) {
        _list = _list.filter(info => info.id !== 'C50EADF2')
      }
      // 停车管理
      if (!this.isOpenTcc) {
        _list = _list.filter(info => info.id !== 'FA521839')
      }

      _list.forEach(element => {
        if (isEmpty(element.path)) {
          element.path = ''
        }
        element.path = element.url
        element.meta = {
          title: element.name,
          icon: element.cssClass
        }
        if (element.children) {
          if (
            element.id === 'FBD7E136' && // 有统计权限
            this.hierarchyType !== 'MD' && // 非门店账号
            this.isOpenCheckIn // 开启多商家
          ) {
            if (!element.children.some(info => info.id === 'i98cu7cy')) {
              element.children.push({
                id: 'i98cu7cy',
                path: 'flow-statistics',
                url: 'flow-statistics',
                meta: {
                  title: '流量统计',
                  icon: 'example'
                },
                name: '流量统计'
              })
            }
          }
          if (this.hierarchyType === 'GS') {
            // 统计
            if (element.id === 'FBD7E136') {
              // if (
              //   element.children.some(info => info.id === 'EC38FACC') &&
              //   !element.children.some(info => info.id === '79c68301')
              // ) {
              //   element.children.push({
              //     id: '79c68301',
              //     path: 'all-business-summary',
              //     url: 'all-business-summary',
              //     meta: {
              //       title: '全品牌营业统计',
              //       icon: 'example'
              //     },
              //     name: '全品牌营业统计'
              //   })
              // }
              // if (
              //   element.children.some(info => info.id === 'C9C2E3F4') &&
              //   !element.children.some(info => info.id === '830103c8')
              // ) {
              //   element.children.push({
              //     id: '830103c8',
              //     path: 'all-cross-shop-settlement',
              //     url: 'all-cross-shop-settlement',
              //     meta: {
              //       title: '全品牌跨店结算',
              //       icon: 'example'
              //     },
              //     name: '全品牌跨店结算'
              //   })
              // }
              if (this.isOpenYy) {
                element.children.push({
                  id: '248u6eeo',
                  path: 'appointment-statistics',
                  url: 'appointment-statistics',
                  meta: {
                    title: '预约统计',
                    icon: 'example'
                  },
                  name: '预约统计'
                })
              }
            } else if (element.id === 'B73747DE') {
              // 会员
              // 品牌互通且等级互通
              if (this.isDifferBrandInteract && this.isGradeInterflow) {
                if (
                  element.children.some(info => info.id === 'A44D66C6') &&
                  !element.children.some(info => info.id === '4a4t0ucm')
                ) {
                  element.children.push({
                    id: '4a4t0ucm',
                    path: 'all-user-list',
                    url: 'all-user-list',
                    meta: {
                      title: '全品牌会员列表',
                      icon: 'example'
                    },
                    name: '全品牌会员列表'
                  })
                }
                if (
                  element.children.some(info => info.id === '3BFCC6BF') &&
                  !element.children.some(info => info.id === '4g7i8cv5')
                ) {
                  element.children.push({
                    id: '4g7i8cv5',
                    path: 'all-user-grade',
                    url: 'all-user-grade',
                    meta: {
                      title: '全品牌会员等级',
                      icon: 'example'
                    },
                    name: '全品牌会员等级'
                  })
                }
              }
            } else if (
              (element.id === '9E66269F' || element.id === '785106BB') &&
              this.isInitCreat &&
              !element.children.some(info => info.id === '1t5cx8er')
            ) {
              // 系统权限
              element.children.push({
                id: '1t5cx8er',
                path: 'custom-basic',
                url: 'custom-basic',
                meta: {
                  title: '公司自定义配置',
                  icon: 'example'
                },
                name: '公司自定义配置'
              })
            }
          } else {
            if (element.id === 'FBD7E136') {
              if (this.isOpenYy) {
                element.children.push({
                  id: '248u6eeo',
                  path: 'appointment-statistics',
                  url: 'appointment-statistics',
                  meta: {
                    title: '预约统计',
                    icon: 'example'
                  },
                  name: '预约统计'
                })
              }
            }
            // if (
            //   element.id === '9E66269F' &&
            //   !element.children.some(info => info.id === '2d8uioe4')
            // ) {
            //   // 系统权限
            //   element.children.push({
            //     id: '2d8uioe4',
            //     path: 'custom-page',
            //     url: 'custom-page',
            //     meta: {
            //       title: '工作台',
            //       icon: 'example'
            //     },
            //     name: '工作台'
            //   })
            // }
          }
          element.children.forEach((item, index) => {
            item.path = item.url
            item.meta = {
              title: item.name,
              icon: 'example'
            }
          })
        }
        // if (element.id === '16E270B6') {
        //   // 首页
        //   element.path = '/home'
        //   element.meta = {
        //     title: element.name,
        //     icon: 'icon iconfont iconshouye-copy'
        //   }
        // } else if (element.id === '9E66269F') {
        //   // 系统设置
        //   element.path = '/system'
        //   element.meta = {
        //     title: element.name,
        //     icon: 'icon iconfont iconshezhi'
        //   }
        //   if (element.children) {
        //     element.children.forEach((item, index) => {
        //       if (item.id === '78487BC3') {
        //         item.path = 'staff-list'
        //         item.meta = {
        //           title: item.name,
        //           icon: 'example'
        //         }
        //       } else if (item.id === '3E9B5AAE') {
        //         item.path = 'shop-information'
        //         item.meta = {
        //           title: item.name,
        //           icon: 'example'
        //         }
        //         // } else if (item.id === '92E5B787') {  // 营业设置
        //         //   item.path = 'express-template'
        //         //   item.meta = {
        //         //     title: item.name,
        //         //     icon: 'example'
        //         //   }
        //       } else if (item.id === 'D320B9D7') {
        //         item.path = 'edit-role-permission'
        //         item.meta = {
        //           title: item.name,
        //           icon: 'example'
        //         }
        //       } else if (item.id === 'EAC6752D') {
        //         item.path = 'decoration/index'
        //         item.meta = {
        //           title: item.name,
        //           icon: 'example'
        //         }
        //       }
        //     })
        //   }
        // } else {
        //   element.path = '/nested'
        //   element.meta = {
        //     title: element.name,
        //     icon: 'icon iconfont iconyingxiao'
        //   }
        // }
      })
      // if (!_list.some(info => info.id === '17ci9yrw')) {
      //   _list.push({
      //     useType: 'PT',
      //     filterAuth: '1',
      //     updateTime: '',
      //     status: '',
      //     iconUrl: '',
      //     orderNum: '10000',
      //     type: 'menu',
      //     operateId: '',
      //     url: '/custom',
      //     path: '/custom',
      //     funValue: '',
      //     id: '17ci9yrw',
      //     parentId: '-1',
      //     operateName: '',
      //     insertTime: '2019-11-28 10:56:38',
      //     name: '工作台',
      //     meta: {
      //       icon: 'icon iconfont iconfuwupingjia',
      //       title: '工作台'
      //     },
      //     isShow: true,
      //     roleFunctionId: '19A9C84B3711878145',
      //     grade: '1',
      //     cssClass: 'icon iconfont iconshouye-copy',
      //     isCheckFunctionAuth: '0',
      //     roleId: '191128B13A200BC495'
      //   })
      // }

      this.setNavList(_list)
      return _list
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      //  if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      //  return this.$store.state.settings.sidebarLogo
      return true
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    businessModeList() {
      let businessMode = this.companyInfo.businessMode || ''
      if (isEmpty(businessMode)) {
        return []
      } else {
        return businessMode.split(',')
      }
    },
    isOpenFunConfig() {
      return this.brandInfo.isOpenFunConfig || {}
    },
    // 是否开启社区团购
    isOpenCommunityBuying() {
      if (
        this.businessModeList.some(info => info === '2') &&
        this.brandInfo.isOpenCommunityBuying === '1'
      ) {
        return true
      } else {
        return false
      }
      // return this.brandInfo.isOpenCommunityBuying === '1'
    },
    // 多商家入驻
    isOpenCheckIn() {
      if (
        this.businessModeList.some(info => info === '3') &&
        this.brandInfo.isOpenCheckIn === '1'
      ) {
        return true
      } else {
        return false
      }
    },
    functionAuth() {
      return this.brandInfo.functionAuth || []
    },
    // 仓库管理
    isOpenCkgl() {
      return (
        this.functionAuth.some(info => info.type === 'CKGL') &&
        this.isOpenFunConfig.b === '1'
      )
    },
    // 品牌互通
    isDifferBrandInteract() {
      return this.companyInfo.isDifferBrandInteract === '1'
    },
    // 等级互通
    isGradeInterflow() {
      return this.companyInfo.isGradeInterflow === '1'
    },
    // 发布新闻
    isOpenNews() {
      return (
        this.isOpenFunConfig.k === '1' &&
        this.functionAuth.some(info => info.type === 'FBXW')
      )
    },
    // 预约
    isOpenYy() {
      return this.functionAuth.some(info => info.type === 'YY')
    },
    // 服务员评价
    isOpenStaffEvaluate() {
      return (
        this.isOpenFunConfig.j === '1' &&
        this.functionAuth.some(info => info.type === 'FWYPJ')
      )
    },
    isInitCreat() {
      return this.userInfo.isInitCreat === '1'
    },
    corpWechatConfig() {
      return this.companyInfo.corpWechatConfig || {}
    },
    // 企业微信客服
    isOpenWxService() {
      return this.corpWechatConfig.a === '1'
    },
    // 门店评价
    isOpenMdpj() {
      return this.functionAuth.some(info => info.type === 'MDPJ')
    },
    // 订单评价
    isOpenDdpj() {
      return this.functionAuth.some(info => info.type === 'DDPJ')
    },
    // 视频获客
    isOpenSphk() {
      return this.functionAuth.some(info => info.type === 'SPHK')
    },
    // 案例内容
    isOpenAlnr() {
      return this.functionAuth.some(info => info.type === 'ALNR')
    },
    // 平台模式——爆客侠
    isOpenPtms() {
      return this.businessModeList.some(info => info === '5')
    },
    // 客服中心
    isOpenKfzx() {
      return this.functionAuth.some(info => info.type === 'KFZX')
    },
    // 招聘板块
    isOpenZpbk() {
      return this.functionAuth.some(info => info.type === 'ZPBK')
    },
    // 霸王餐功能
    isOpenBwcgn() {
      let bool = this.functionAuth.some(info => info.type === 'BWC')
      return this.isOpenFunConfig.a1 === '1' && bool
    },
    // 零食盒子
    isOpenLshz() {
      return this.functionAuth.some(info => info.type === 'LSHZ')
    },
    // 同城交友
    isOpenTcjy() {
      let bool = this.functionAuth.some(info => info.type === 'TCJY')
      return this.isOpenFunConfig.i1 === '1' && bool
    },
    // 公司开启站点运营考核
    isOpenSiteExamine() {
      return this.companyInfo.isOpenSiteExamine === '1'
    },
    // 活动赛事
    isOpenHdss() {
      return this.functionAuth.some(info => info.type === 'HDSS')
    },
    // 论坛
    isOpenLt() {
      return this.functionAuth.some(info => info.type === 'LT')
    },
    isOpenTcc() {
      return this.functionAuth.some(info => info.type === 'TCC')
    },
    // 门店开启自动分账
    shopOpenProfit() {
      return this.shopInfo.openProfit === '1'
    }
  },
  methods: {
    ...mapMutations(['setNavList']),
    handleMenuList(list) {
      let functionAuthMap = generatorMap(
        this.brandInfo.functionAuth || [],
        'type',
        false
      )
      list.forEach(item => {
        item.isShow = true
        if (item.isCheckFunctionAuth === '1' && !isEmpty(item.funValue)) {
          if (!functionAuthMap[item.funValue]) {
            item.isShow = false
          }
        }
      })
      const parentList = list.filter(
        item =>
          item.useType !== 'SY' &&
          Number(item.parentId) === -1 &&
          Number(item.grade) === 1 &&
          item.type === 'menu' &&
          item.isShow
      )
      const sonList = list.filter(
        item =>
          Number(item.parentId) !== -1 &&
          Number(item.grade) === 2 &&
          item.type === 'menu' &&
          item.isShow
      )
      parentList.forEach(pItem => {
        pItem.children = []
        sonList.forEach(sItem => {
          if (sItem.parentId === pItem.id) {
            //  如果没有就创建一个
            if (!pItem.hasOwnProperty('children')) {
              pItem.children = []
            }
            pItem.children.push(sItem)
          }
        })
      })
      return parentList
    }
  }
}
</script>
<style lang="scss">
.my-el-menu {
  .menu-wrapper {
    text-align: center !important;
    .el-submenu__title {
      span {
        display: none !important;
      }
    }
  }
}
</style>
